export default function initPasswordToggle() {
  const formPassword = document.querySelectorAll('.form-group-password');

  if (!formPassword.length) return;

  formPassword.forEach((form) => {
    const input = form.querySelector('.password-input');
    const toggle = form.querySelector('.password-visibility');

    if (!input || !toggle) return;

    toggle.classList.add('disabled');

    input.addEventListener('input', () => {
      toggle.classList.toggle('disabled', input.value.length === 0);
    });

    toggle.addEventListener('click', () => {
      if (input.value.length > 0) {
        toggle.classList.toggle('visible');
        input.type = input.type === 'password' ? 'text' : 'password';
        toggle.setAttribute('aria-label', input.type === 'password' ? 'Show password' : 'Hide password');
      }
    });
  });
}
